import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import { BrowserRouter } from 'react-router-dom';
import { renderRoutes } from 'react-router-config'
import { AppContainer } from 'react-hot-loader';
import { App } from './modules';
import { routes } from './routes';
import configureStore from './store';

const initialState = window.__INITIAL_STATE__;
const store = configureStore(initialState)

const AppRouter = () => {
    return (
        <AppContainer>
            <Provider store={store}>
                <div 
                    style={{
                        height: '100%'
                    }}
                >
                    <BrowserRouter>
                        {renderRoutes(routes)}
                    </BrowserRouter>
                </div>
            </Provider>
        </AppContainer>
    )
}

ReactDOM.render(<AppRouter />, document.getElementById('root'));

if (module.hot) {
    module.hot.accept()
}


// WEBPACK FOOTER //
// ./client/index.js